import './pass_btn.css';

const PassBtn = ({ text, onClick, type = 'button', direction = 'next', className = '' }) => {
    const btnClass = direction === 'next' ? 'BotaoProximo' : 'BotaoAnterior';
    return (
        <button
            type={type}
            className={`${btnClass} ${className}`}
            onClick={onClick}
        >
            {text}
        </button>
    );
};

export default PassBtn;
